import React from 'react';
import {Image, View} from 'react-native';
import colors from '../config/colors';
import AppText from './AppText';

function CommonHeader(props) {
  return (
    <>
      <Image
        source={require('../assets/city_landscape_small.jpg')}
        style={{
          height: 150,
          width: '100%',
          position: 'absolute',
          // resizeMode: "contain",
        }}></Image>
      <View
        style={{
          // flex: 1,
          height: 150,
          backgroundColor: colors.primaryTrans,
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        {/* <AppText
          style={{
            fontWeight: 'bold',
            marginBottom: 8,
            textAlign: 'center',
            marginTop: 10,
            marginHorizontal: 6,
          }}
          color="transparent"
          textColor="white">
          Qualify as aprofessional, a student or an investor, for Europe, North
          America or Australia.
        </AppText>
        <AppText
          style={{textAlign: 'center', paddingLeft: 20, paddingRight: 20}}
          color="transparent"
          textColor="white">
          Quickest way on the internet to verify your Score.
        </AppText> */}
        <AppText
          style={{
            marginTop: 10,
            marginHorizontal: 6,
            // width: '70%',
            fontSize: 22,
            textAlign: 'center',
            alignSelf: 'center',
          }}
          color="transparent"
          textColor="white">
          Filing for Immigration?{'\n'}Know forehand if you qualify!
        </AppText>
        <AppText
          style={{
            // width: '70%',
            textAlign: 'center',
            alignSelf: 'center',
            fontSize: 22,
            fontWeight: 'bold',
            paddingHorizontal: 20,
            // marginBottom: 20,
          }}
          color="transparent"
          textColor="white">
          Quickest way on the internet{'\n'}to verify your Score.
        </AppText>
      </View>
    </>
  );
}

export default CommonHeader;
